import { useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { DomainSearchGateModule } from '../../../../module/domainSearchGate.module';
import { syncQueryToStore } from '../utils/syncQueryToStore';
export const useSearchField = _ref => {
  let queryFromUrl = _ref.queryFromUrl,
    onGenerate = _ref.onGenerate;
  const history = useHistory();
  const _useState = useState(queryFromUrl),
    inputValue = _useState[0],
    setInputValue = _useState[1];
  useEffect(() => {
    setInputValue(queryFromUrl);
  }, [queryFromUrl]);
  const onSubmit = useCallback(() => {
    const nextQuery = inputValue.trim();
    if (!nextQuery) {
      return;
    }
    DomainSearchGateModule.internals.bi.onBngGeneralAction == null || DomainSearchGateModule.internals.bi.onBngGeneralAction({
      action: 'generate',
      value: nextQuery,
      button_name: 'generate',
      domain: '',
      search_term: nextQuery
    });
    syncQueryToStore(nextQuery);
    onGenerate == null || onGenerate();
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    history.push(`/?query=${encodeURIComponent(nextQuery)}`);
  }, [history, inputValue, onGenerate]);
  return {
    value: inputValue,
    onChange: setInputValue,
    onSubmit
  };
};
//# sourceMappingURL=useSearchField.js.map